import { Component, Injectable, ViewChild, OnInit } from '@angular/core';
import { RequestsService } from '../../services/requests.service';
import { ToastService } from '../../services/toast.service';
import { ModalComponent, ModalConfig } from '../../_helpers/modal/modal.component'
import { ModalperguntaComponent } from '../../_helpers/modalpergunta/modalpergunta.component'
import { ModalcloneComponent } from '../../_helpers/modalclone/modalclone.component'
import { Cabecalho } from '../../models/cabecalho.model';
import { Dataset } from '../../models/dataset.model';
import { MonacoEditorComponent } from '@materia-ui/ngx-monaco-editor';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'add-cabecalho',
  styleUrls: ['./add-cabecalho.component.scss'],
  templateUrl: "./add-cabecalho.component.html"
})

export class AddCabecalhoComponent implements ModalConfig, OnInit {
  cabecalhoForm: FormGroup;
  submitted = false;
  disableSubmit = false;
  public data: string;
  public modalTitle = "Cadastro/Edição de Cabeçalho";
  public modalperguntaTitle = "Tem certeza que gostaria de excluir o Cabeçalho?";
  public closeButtonLabel = "Fechar";
  public idProjeto;
  
  editorOptions = {theme: 'vs-dark', language: 'html'};
  @ViewChild('editor', { static: true }) private editor: MonacoEditorComponent
  @ViewChild('modal', { static: true }) private modalComponent: ModalComponent
  @ViewChild('modalpergunta', { static: true }) private modalperguntaComponent: ModalperguntaComponent
  @ViewChild('modalclone', { static: true }) private modalcloneComponent: ModalcloneComponent

  cabecalho: Cabecalho = new Cabecalho();
  datasets: Dataset[] = [];

  constructor(private formBuilder: FormBuilder,
              private requestService: RequestsService,
              private toastService: ToastService) { }

  ngOnInit() {
    this.cabecalhoForm = this.formBuilder.group({
      nome: ['', Validators.required],
      dataset: ['', Validators.required],
      html: ['', Validators.required]
    })
  }

  get f() { return this.cabecalhoForm.controls; }

  public hideDismissButton() {
    return true;
  }

  async abrir(registro, idProjeto) {
    this.submitted = false;
    this.disableSubmit = false;
    this.cabecalhoForm.markAsUntouched();

    if (registro)
      this.cabecalho = registro;
      else
      this.cabecalho = new Cabecalho();

    this.idProjeto = idProjeto;
    this.iniciar();
    return await this.modalComponent.open();
  }

  async fechar() {
    await this.modalComponent.close();
  }

  salvar() {
    this.submitted = true;
    if (this.cabecalhoForm.invalid) {
      return;
    }

    this.cabecalho.idProjeto = this.idProjeto;

    this.disableSubmit = true;
    var request = this.cabecalho.idCabecalho > 0 ? this.requestService.updateCabecalho(this.cabecalho) : this.requestService.insertCabecalho(this.cabecalho);

    request.subscribe(rsp => {
      this.fechar();
      this.toastService.showSuccess("Cabeçalho salvo com sucesso.")
    }, error => {
      this.disableSubmit = false;
      console.log(error)
    });
  }

  async delete(id) {
    await this.modalperguntaComponent.open();
    return await this.modalperguntaComponent.continue(this.modalperguntaComponent.isConfirmed);
  }

  async clone(registro) {
    await this.modalcloneComponent.open(registro.idProjeto);
    var x = await this.modalcloneComponent.continue(this.modalcloneComponent.isConfirmed);
    if (x) {
      this.cabecalho = registro;
      this.cabecalho.idProjeto = this.modalcloneComponent.idProjeto;
      var request = this.requestService.insertCabecalho(this.cabecalho);
      request.subscribe(rsp => {
        this.toastService.showSuccess("Clone feito com sucesso.")
      }, error => {
        console.log(error)
      });
    }
  }

  iniciar() {
    this.requestService.listDatasetsByProjeto(this.idProjeto).subscribe(x => {
      this.datasets = x;
    });
  }

}
